<template>
  <Card
    title="Personal Info"
    direction="column"
    color="background"
    background="pink-dark"
  >
    <TextComponent color="background" type="paragraph" as="p">
      Email:
      <TextComponent
        :href="`mailto:${data.email}`"
        color="background"
        type="paragraph"
        as="a"
      >
        {{ data.email }}
      </TextComponent>
    </TextComponent>
    <TextComponent
      as="p"
      color="background"
      type="paragraph"
      v-if="data.hackerApplication.phoneNumber"
    >
      Phone:
      <TextComponent
        :href="`tel:${data.hackerApplication.phoneNumber}`"
        color="background"
        type="paragraph"
        as="a"
      >
        {{ data.hackerApplication.phoneNumber }}
      </TextComponent>
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Gender: {{ data.hackerApplication.gender }}
    </TextComponent>
    <TextComponent as="p" color="background" type="paragraph">
      Pronouns: {{ data.hackerApplication.pronouns }}
    </TextComponent>
    <TextComponent as="p" color="background" type="paragraph">
      Ethnicity: {{ data.hackerApplication.ethnicity }}
    </TextComponent>
    <TextComponent as="p" color="background" type="paragraph">
      Interested in prevent workshops: {{ data.hackerApplication.preEventWorkshops }}
    </TextComponent>
  </Card>
</template>

<script>
  import TextComponent from '@hackthe6ix/vue-ui/Text';
  import Card from '../../../../containers/Card';

  export default {
  name: 'PersonalInfo',
  components: {
    TextComponent,
    Card,
  },
  props: {
    data: Object,
  },
};
</script>
